import { FC, useState } from 'react';
import { CandidateType } from '../Candidates/Candidates';
import ButtonLink from 'components/ButtonLink';
import { PopupModal } from 'components/PopupModal';
import { getCustomCheckoutLink } from 'helpers/donate';
import { getDonatePageData } from 'selectors/donatePage';
import { getUrlParams } from 'helpers/utils';
import { useAppSelector } from 'helpers/hooks';
import { getEventData } from 'selectors/eventPage';

interface Props {
  candidates: CandidateType[];
  isRecurring?: boolean;
}

export const CustomLinkCopy: FC<Props> = ({ candidates, isRecurring = false }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { urlEvent } = getUrlParams();
  const { donatePageData, eventData } = useAppSelector(state => ({
    donatePageData: getDonatePageData(state),
    eventData: getEventData(state),
  }));

  const handleCopy = () => {
    const pageData = urlEvent ? eventData : donatePageData;
    if (!pageData) {
      return;
    }
    navigator.clipboard.writeText(getCustomCheckoutLink(pageData, candidates, isRecurring));
    setIsPopupOpen(true);
    setTimeout(() => setIsPopupOpen(false), 2000);
  };

  return (
    <>
      <PopupModal autoClose={true} isSelected={isPopupOpen} title="Copied to Clipboard" />
      <ButtonLink onClick={handleCopy}>Copy Checkout Link</ButtonLink>
    </>
  );
};
